import { SmartMTEditorPopup } from "./_editor_popup";
import { getCurrentMimeType, getBlobUrl, getImgBlob, setImgBlob, setCurrentMode, showToastMessage } from "./_utils";
import UPNG from 'upng-js';  // Import UPNG.js

var $ = jQuery;

export const Compress = (attachment) => {
    $('#smart-mt-compress').on('click', async function () {
        setCurrentMode('compress');
        let originalBlob = getImgBlob();
        let url = getBlobUrl(originalBlob) !== false ? getBlobUrl(originalBlob) : attachment.url;

        let compressContent = `
      <div class="smart-mt-content smart-mt-content-compress">
          <img id="smartmt-edit-image" src="${url}" alt="${attachment.name}" crossorigin="anonymous" />
      </div>`;

        let compressSidebar = `
      <div class="sidebareffects compress-controls">
          <label for="compression-level">Image Quality:</label>
          <input id="compression-level" type="range" min="10" max="100" value="65" />
          <span id="compression-level-value">65%</span>
          <p><strong>Original Size:</strong> <span> ${attachment.filesizeHumanReadable}</span></p>
          <p><strong>Compressed Size:</strong> <span id="compressed-size" style="color: #28c72e;"> Waiting...</span></p>
          <div class="progress-bar-container">
              <div class="progress-bar" id="compression-progress" style="width: 0%;"></div>
          </div>
      </div>
      <div class="button-access">
          <button class="button" id="apply-compress">
              <span class="dashicons dashicons-saved"></span> Apply
          </button>
      </div>`;

        SmartMTEditorPopup(compressContent, compressSidebar);

        // Wait until the image element is loaded
        const imageElement = document.getElementById("smartmt-edit-image");
        await waitForImageLoad(imageElement);

        // Get the original image blob if not already available.
        if (!originalBlob) {
            try {
                originalBlob = await fetch(imageElement.src).then(res => res.blob());
            } catch (err) {
                console.error("Failed to fetch original image blob:", err);
                showToastMessage("Failed to fetch original image blob.", "error");
                return;
            }
        }

        // Automatically compute an optimal quality value.
        try {
            const { quality, blob } = await autoComputeQuality(imageElement, originalBlob, 0.5); // target: 50% of original size
            const qualityPercent = Math.round(quality * 100);
            // Update the slider and display with the computed value.
            $('#compression-level').val(qualityPercent);
            $('#compression-level-value').text(qualityPercent + "%");
            updateCompressedSize(blob);
        } catch (err) {
            console.error("Auto-compression quality computation failed:", err);
        }

        initCompressControls();
    });

    function initCompressControls() {
        $('#compression-level').on('input', function () {
            const level = $(this).val();
            $('#compression-level-value').text(level + "%");
            estimateCompressedSize(level);
        });

        $('#apply-compress').on('click', function () {
            applyCompression(parseInt($('#compression-level').val()));
        });
    }

    function applyCompression(compressionLevel) {
        const imageElement = document.getElementById("smartmt-edit-image");

        if (!imageElement) {
            console.error("Image element not found.");
            showToastMessage("Image element not found.", "error");
            return;
        }

        $('#compression-progress').css("width", "10%");

        compressImage(imageElement, compressionLevel / 100)
            .then((blob) => {
                if (blob) {
                    $('#compression-progress').css("width", "100%");
                    updateImageAfterCompression(imageElement, blob);
                    showToastMessage(`Image compressed to ${compressionLevel}% quality.`, "success");
                } else {
                    showToastMessage("Compression failed. Please try again.", "error");
                }
            })
            .catch((error) => {
                showToastMessage(`Compression error: ${error}`, "error");
            });
    }

    /**
     * Compresses the image using canvas.
     * - For non-PNG images, it uses canvas.toBlob with the quality parameter.
     * - For PNG images, it uses UPNG.js to encode the image while keeping it in PNG format.
     *   (Note: UPNG.encode expects quality as an integer between 0 and 100.)
     */
    function compressImage(imageElement, quality) {
        return new Promise((resolve, reject) => {
            if (!imageElement.complete) {
                imageElement.onload = () => compressImage(imageElement, quality).then(resolve).catch(reject);
                return;
            }

            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");

            canvas.width = imageElement.naturalWidth;
            canvas.height = imageElement.naturalHeight;
            ctx.drawImage(imageElement, 0, 0, canvas.width, canvas.height);

            let mimeType = getCurrentMimeType() || "image/jpeg";

            if (mimeType === "image/png") {
                // Use UPNG.js to compress PNG images while preserving the PNG format.
                try {
                    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                    // UPNG.encode expects an array of ArrayBuffer(s) for each frame.
                    // Here, we pass the underlying buffer of the image data.
                    const pngQuality = Math.round(quality * 100); // convert quality from [0,1] to [0,100]
                    const encoded = UPNG.encode([imageData.data.buffer], canvas.width, canvas.height, pngQuality);
                    const blob = new Blob([encoded], { type: "image/png" });
                    resolve(blob);
                } catch (err) {
                    console.error("PNG compression failed using UPNG:", err);
                    reject(err);
                }
            } else {
                // For JPEG, WebP, etc.
                canvas.toBlob((blob) => {
                    if (blob) {
                        resolve(blob);
                    } else {
                        console.error("Compression failed. Trying fallback...");
                        fetch(imageElement.src)
                            .then(res => res.blob())
                            .then(resolve)
                            .catch(err => reject("Fallback compression failed: " + err));
                    }
                }, mimeType, quality);
            }
        });
    }

    function estimateCompressedSize(compressionLevel) {
        const imageElement = document.getElementById("smartmt-edit-image");
        if (!imageElement) { return; }

        compressImage(imageElement, compressionLevel / 100)
            .then((blob) => updateCompressedSize(blob))
            .catch(err => console.error("Estimate failed:", err));
    }

    function updateImageAfterCompression(imageElement, blob) {
        if (!blob) {
            console.error("Blob is null after compression.");
            return;
        }

        const compressedImageURL = getBlobUrl(blob);
        setImgBlob(blob);
        imageElement.src = compressedImageURL;
        updateCompressedSize(blob);
    }

    function updateCompressedSize(blob) {
        if (!blob) {
            console.error("Invalid compressed blob.");
            return;
        }
        const sizeInKB = (blob.size / 1024).toFixed(2);
        $('#compressed-size').text(`${sizeInKB} KB`);
    }

    // Helper: Wait for an image element to finish loading.
    function waitForImageLoad(image) {
        return new Promise((resolve) => {
            if (image.complete) {
                resolve();
            } else {
                image.onload = () => resolve();
            }
        });
    }

    /**
     * Automatically compute the optimal quality (a float between 0.1 and 1.0)
     * that yields a compressed blob of roughly the target ratio relative to the original.
     * @param {HTMLImageElement} imageElement - The image element.
     * @param {Blob} originalBlob - The original image blob.
     * @param {number} targetRatio - The desired ratio of compressed size to original size.
     * @returns {Promise<{quality: number, blob: Blob}>}
     */
    function autoComputeQuality(imageElement, originalBlob, targetRatio = 0.5) {
        return new Promise((resolve, reject) => {
            let low = 0.1, high = 1.0;
            const targetSize = originalBlob.size * targetRatio;
            const tolerance = 1024; // 1KB tolerance

            function search() {
                const mid = (low + high) / 2;
                compressImage(imageElement, mid).then(blob => {
                    if (Math.abs(blob.size - targetSize) < tolerance || (high - low) < 0.01) {
                        resolve({ quality: mid, blob });
                    } else if (blob.size > targetSize) {
                        high = mid;
                        search();
                    } else {
                        low = mid;
                        search();
                    }
                }).catch(reject);
            }
            search();
        });
    }
};
